import React from 'react';
import { Quill } from 'react-quill';
import PropTypes from 'prop-types';
import StyledEditor from './style';

const Link = Quill.import('formats/link');
const builtInFunc = Link.sanitize;

Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  let val = linkValueInput;
  if (!/^https?:/.test(val)) {
    val = `http:${val}`;
  }

  return builtInFunc.call(this, val);
};

const Editor = ({ className, onChange, onBlur, disabled, value }) => (
  <StyledEditor
    className={className}
    onChange={onChange}
    onBlur={onBlur}
    readOnly={disabled}
    value={value}
  />
);

Editor.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string
};

Editor.defaultProps = {
  disabled: false
};

export default Editor;
